// extracted by mini-css-extract-plugin
export var addToCartButton = "_p0-b";
export var arrowButtonContainer = "_p0-9";
export var arrowButtonIcon = "_p0-a";
export var carouselArrowButton = "_p0-6";
export var carouselElementContainer = "_p0-1";
export var galleryThumbnail = "_p0-d";
export var galleryThumbnailImage = "_p0-e";
export var left = "_p0-7";
export var productDisplayCarouselContainer = "_p0-0";
export var productTileContainer = "_p0-2";
export var productTileImage = "_p0-4";
export var productTileImageContainer = "_p0-3";
export var productTileTitle = "_p0-5";
export var right = "_p0-8";
export var sliderOverflow = "_p0-c";